<template>
  <div>
    <sample-header> </sample-header>
    <div class="dynamic-content">
      <h1>Uh oh</h1>
      <p>Something unexpected happened. If the problem persists please email our support team at
        <a href="mailto:Support@essilorsupport.com?subject=Error on site">Support@essilorsupport.com</a>
      </p>
      <router-link to="/">Go to Start</router-link>
    </div>
    <sample-footer> </sample-footer>
  </div>
</template>

<script>
import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";

export default {
  components: { SampleHeader, SampleFooter }
};
</script>
